import type { ResolveRoundAction } from "../types/action";
import type { ValidationResult } from "../types/common";
import type { HorrorRaceState } from "../types/game-state";

export function validateResolveRound(
  state: HorrorRaceState,
  action: ResolveRoundAction,
): ValidationResult {
  if (action.resolverId !== state.hostPlayerId)
    return { valid: false, error: "Only the host can resolve the round" };
  if (state.phase !== "ROUND_RESOLVE") {
    return { valid: false, error: "Not in round resolve phase" };
  }

  return { valid: true };
}
